import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JobDetailsComponent } from './jobDetails.component';
import { FormsModule }   from '@angular/forms';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import {SharingModule} from "../sharing/sharing.module";
import {ClipboardModule} from "ngx-clipboard";
import { SharedModule } from '../shared/shared.module';
import { AttachmentsModalComponent } from '../shared/attachments-modal/attachments-modal.component';


@NgModule({
    imports: [CommonModule, FormsModule, PdfViewerModule, SharingModule, ClipboardModule, SharedModule, AttachmentsModalComponent],
    declarations: [JobDetailsComponent],
    exports: [JobDetailsComponent]
})

export class JobDetailsModule { }
